export function startBroadcastInterruptEffect({ imgPanelEl }) {
  if (!imgPanelEl) return () => {};

  const canvas = imgPanelEl.querySelector('canvas.scanline-canvas');
  if (!canvas) return () => {};

  const ctx = canvas.getContext('2d');
  if (!ctx) return () => {};

  let scanY = 0;

  const resize = () => {
    const w = imgPanelEl.offsetWidth || 0;
    const h = imgPanelEl.offsetHeight || 0;
    if (w <= 0 || h <= 0) return;
    canvas.width = w;
    canvas.height = h;
  };

  resize();

  const observer = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(resize) : null;
  if (observer) observer.observe(imgPanelEl);

  const intervalId = setInterval(() => {
    if (!canvas.isConnected) return;

    const w = canvas.width;
    const h = canvas.height;
    if (w <= 0 || h <= 0) return;

    ctx.clearRect(0, 0, w, h);

    // Horizontal scanlines
    for (let y = 0; y < h; y += 4) {
      ctx.fillStyle = 'rgba(0, 0, 0, 0.12)';
      ctx.fillRect(0, y, w, 1);
    }

    // Moving scan line
    ctx.fillStyle = 'rgba(255, 255, 255, 0.25)';
    ctx.fillRect(0, scanY, w, 2);

    scanY += 8;
    if (scanY > h) scanY = 0;
  }, 50);

  return () => {
    clearInterval(intervalId);
    if (observer) observer.disconnect();
  };
}
